
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import router from '@/router'

const actions = {
  loginAttempt({ dispatch }, payload) {
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation
    }

    if (!payload.checkbox_remember_me) {
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
        .then(function () {
          dispatch('login', newPayload)
        })
        .catch(function (err) {
          if (payload.closeAnimation) payload.closeAnimation()

          payload.notify({
            time: 2500,
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    } else {
      dispatch('login', newPayload)
    }
  },
  login({ commit, state, dispatch }, payload) {
    if (state.isUserLoggedIn()) {
      if (payload.closeAnimation) payload.closeAnimation()

      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })

      return false
    }

    firebase.auth().signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)

      .then((result) => {

        let isUsernameUpdateRequired = false

        if (payload.updateUsername && payload.userDetails.displayName) {

          isUsernameUpdateRequired = true

          dispatch('updateUsername', {
            user: result.user,
            username: payload.userDetails.displayName,
            notify: payload.notify,
            isReloadRequired: true
          })
        }

        if (payload.closeAnimation) payload.closeAnimation()

        if (!isUsernameUpdateRequired) {
          router.push(router.currentRoute.query.to || '/pages/orders')
          commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
        }
      }, (err) => {

        if (payload.closeAnimation) payload.closeAnimation()

        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
  },

  signInGuest({ state }) {
    if (!state.isUserLoggedIn())
      firebase.checkbox_remember_me
    firebase.auth().signInAnonymously().then(() => {
    }).catch(function (error) {
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(errorCode);
      console.log(errorMessage)
      // ...
    });
  },
  UPDATE_USER_INFO(state, payload) {
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser
    for (const property of Object.keys(payload)) {

      if (payload[property] != null) {
        state.AppActiveUser[property] = payload[property]

        userInfo[property] = payload[property]
      }


    }
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },
  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },
  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  toggleRestInWishList({ commit }, item) {
    commit('TOGGLE_REST_IN_WISH_LIST', item)
  },
  toggleRestInRestList({ commit }, item) {
    commit('TOGGLE_REST_IN_REST_LIST', item)
  },
  removeAllRestList({ commit }) {
    commit('REMOVE_REST_LIST')
  },
  removeCurrentItem({ commit }) {
    commit('REMOVE_CURR_ITEM')
  },
  toggleCurrentItem({ commit }, item) {
    commit('TOGGLE_CURR_ITEM', item)
  },
  toggleMealInMealList({ commit }, item) {
    commit('TOGGLE_MEAL_IN_MEAL_LIST', item)
  },
  toggleItemInCart({ getters, commit, dispatch }, item) {
    getters.isInCart(item.objectID) ? commit('REMOVE_ITEM_FROM_CART', item) : dispatch("additemInCart", item)
  },
  signOutUser({ state }) {
    if (state) {
      firebase.auth().signOut().then(function () {
        router.push(router.currentRoute.query.to || '/pages/Login')
      }, function (error) {
        console.error('Sign Out Error', error);
      });
    }
  },
  createNewOrder({ commit, state }, item) {
    if (state.getUserInfo()) {
      const usr = state.getUserInfo();
      const db = firebase.firestore();
      item['created_at'] = firebase.firestore.FieldValue.serverTimestamp();
      item['updated_at'] = firebase.firestore.FieldValue.serverTimestamp();
      item['order_status'] = "WP"; 
      item['uid'] = usr.uid;
      item['lang'] = state.language;
      db.collection("order").add(item)
        .then(function () {
          commit('REMOVE_REST_LIST');
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
      
      return true;
    }
  },
  findOrderByPhoneNumber({ commit }, phone) {
    const db = firebase.firestore();
    const orderRef = db.collection("order").orderBy("created_at", "asc");
    commit('CLEAR_ORDER_LIST');
    if (phone) {
      orderRef.where("mobileNum", "==", phone).get()
        .then(
          function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              commit('UPDATE_ORDER_SEARCH_LIST', doc.data());
            });
          })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    }
  },
  additemInCart({ commit }, item) {
    item["quantity"] = 1
    item["discount_in_percentage"] = Math.floor(Math.random() * 20) + 4
    item["offers_count"] = Math.floor(Math.random() * 4) + 1
    item["delivery_date"] = new Date(new Date().getTime() + (Math.random() * 10 * 24 * 60 * 60 * 1000)).toDateString().slice(0, -4)

    commit('ADD_ITEM_IN_CART', item)
  },
  addRestInList({ commit }, item) {
    commit('ADD_REST_IN_LIST', item)
  },
  updateItemQuantity({ commit }, payload) {
    commit('UPDATE_ITEM_QUANTITY', payload)
  },
  fetchOrderListItems({ commit }) {
    const db = firebase.firestore();
    const orderRef = db.collection("order");
    orderRef
      .orderBy("created_at", "desc")
      .onSnapshot(function (querySnapshot) {
        commit('CLEAR_ORDER_LIST_ADMIN');
        querySnapshot.forEach(function (doc) {
          var data = doc.data();
          data['id'] = doc.id;
          commit('UPDATE_ORDER_SEARCH_LIST_ADMIN', data);
        });
      })
    return null;
  },
  updateOrderInfoAdmin({ commit }, orderInfo) {
    const db = firebase.firestore();
    const orderRef = db.collection("order");
    orderInfo['updated_at'] = firebase.firestore.FieldValue.serverTimestamp();
    orderRef.doc(orderInfo.firebaseId).update({
      order_status: orderInfo.order_status,
      deliverer: orderInfo.deliverer,
      remarksInt: orderInfo.remarksInt,
      updated_at: orderInfo.updated_at
    })
      .then(function () {
        commit();
        this.updateLocalOrderListAdmin(orderInfo);
      })
      .catch(function () {
      });
  },

}

export default actions
